import React, { useEffect, useState } from "react";

// JS Files
import Navbar from "../shares/Navbar";
import Footer from "../shares/Footer";
import MuiCollapse from "../shares/MuiCollapse";

// Others File
import lampIcon from "../../imgs/lamp.svg";
import { toast } from "react-toastify";
import useFetch from "../../context/useFetch";

const collapseHeader = (header) => {
  return (
    <>
      <div className="flex items-center">
        <img src={lampIcon} />
        <span className="text-xs md:text-base mr-4 font-bold text-mygray-800">
          {header}
        </span>
      </div>
    </>
  );
};

const Questions = () => {
  const [dataList, setDataList] = useState({ results: [] });
  const getFaqList = useFetch({
    method: "get",
    url: `Faq_Service`,
    trigger: true,
    params:{
      pageSize:100
    },
    noHeader: true,
    setter: setDataList,
    argFunc: (res) => {},
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="hp-section-one">
        <Navbar />
      </div>
      <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
        <p className="header">سوالات پرتکرار</p>
        <div className="border-2 border-myblue-200 rounded-xl mt-8 ">
          {dataList.results.map((item, index) => {
            return [
              <MuiCollapse
                expandedId="1"
                header={collapseHeader(item.question)}
              >
                <div className="flex items-center justify-between">
                  <span className="text-xs md:text-base leading-6 text-mygray-700">
                    {item.answer}
                  </span>
                </div>
              </MuiCollapse>,
            ];
          })}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Questions;
